import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "audio", "noSample"]

  static values = {
    previewUrl: String,
    previews: Object,
  }

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const name = this.selectTarget.value
    const hasSample = Boolean(this.previewsValue[name])

    if (!hasSample) {
      this.audioTarget.hidden = true
      this.audioTarget.removeAttribute("src")
      this.noSampleTarget.hidden = false
      return
    }

    this.noSampleTarget.hidden = true
    this.audioTarget.hidden = false
    this.audioTarget.src = this.previewUrlValue.replace("__VOICE__", encodeURIComponent(name))
    this.audioTarget.load()
  }
}
